import type { Component } from 'vue';
import SalesforceObjectConfigurationAssistant from './SalesforceObjectConfigurationAssistant.vue';

// Generic lookup by AssistantKey (see ConnectionProperty.AssistantKey /
// FieldAssistantAttribute server-side, claude_plans/salesforce-import-plan.md
// §11) - the only place that maps a key string to an actual component.
// ConnectionForm.vue itself never imports an integration-specific component
// directly; adding a new field assistant for a different integration means
// adding one entry here, nothing else in the shared form.
export const fieldAssistants: Record<string, Component> = {
    SalesforceObjectConfiguration: SalesforceObjectConfigurationAssistant,
};
